import { render, staticRenderFns } from "./vsUpload.vue?vue&type=template&id=bc9d7d58"
import script from "./vsUpload.vue?vue&type=script&lang=js"
export * from "./vsUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports